import React, { FC } from 'react'
import { useFormik } from 'formik'
import { createStyles, makeStyles } from '@material-ui/core'

import { StoreCreateDto } from './entities/StoreCreateDto'
import { Modal } from '../../components/_EOS/Modal'
import { StoreForm } from './forms/StoreForm'
import { useApi } from '../../hooks/useApi'
import { create } from './api'
import { Status } from '../../hooks/useFetchState'
import { storeSchema } from './forms/schema'
interface Props {
    open: boolean
    onClose: (success?: boolean) => void
}

export const StoreCreate: FC<Props> = ({
    open,
    onClose,
}) => {
    const { state, callApi } = useApi()

    const styles = useStyles()

    const {
        values,
        errors,
        handleChange,
        resetForm,
        submitForm
    } = useFormik({
        initialValues: {
            code: '',
            name: '',
            streetNumber: '',
            streetName: '',
            state: '',
            city: '',
            neighborhood: '',
            latitude: 0,
            longitude: 0,
            reference: '',
            active: true,
        },
        onSubmit: values => {
            sendData(values)
        },
        validateOnChange: true,
        validationSchema: storeSchema
    })

    const sendData = (store: StoreCreateDto) => {
        callApi(create(store))
            .then(() => {
                resetForm()
                onClose(true)
            })
    }

    const handleSuccessButton = () => {
        submitForm()
    }

    const handleClose = () => {
        resetForm()
        onClose()
    }

    return (
        <Modal
            open={open}
            title='Crear tienda'
            loading={state.status === Status.Loading}
            error={state.status === Status.Error ? state.error : undefined}
            cancelButton={{
                title: 'Cancelar',
                action: handleClose
            }}
            successButton={{
                title: 'Guardar',
                action: handleSuccessButton
            }}>

            <div className={styles.container}>
                <StoreForm values={values} errors={errors} handleChange={handleChange}/>
            </div>

        </Modal>
    )
}

const useStyles = makeStyles(
    createStyles({
        container: {
            display: 'flex',
            flexDirection: 'column',
        },
        input: {
            marginBottom: 20,
        }
    })
)
